import { __awaiter, __generator } from "tslib";
import * as React from 'react';
import WeeklyContextMobile from '../../../context/weeklyContextMobile';
import WixStylesContext from '../../../context/wixStylesContext';
var WeeklyNowIndicator = function () {
    var _a = React.useContext(WixStylesContext), cellBorderWidth = _a.cellBorderWidth, currentTimeLineColor = _a.currentTimeLineColor, mobile_weeklyHoursFontSize = _a.mobile_weeklyHoursFontSize;
    var dateOnFocuse = React.useContext(WeeklyContextMobile).dateOnFocuse;
    React.useEffect(function () {
        var setNowIndicatorInPositionAccordingDesign = function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/];
            });
        }); };
        setNowIndicatorInPositionAccordingDesign();
    }, [dateOnFocuse, mobile_weeklyHoursFontSize]);
    var indicatorSideSize = 9;
    if (window.innerWidth >= 700) {
        if (cellBorderWidth === 1) {
            indicatorSideSize = 9;
        }
        if (cellBorderWidth === 2) {
            indicatorSideSize = 12;
        }
        if (cellBorderWidth === 3) {
            indicatorSideSize = 15;
        }
    }
    else {
        if (cellBorderWidth === 1) {
            indicatorSideSize = 9;
        }
        else {
            indicatorSideSize = 11;
        }
    }
    return (React.createElement("div", { className: "nowIndicator", style: {
            display: 'flex',
            width: "calc(100% + ".concat(indicatorSideSize / 2 - cellBorderWidth, "px)"),
            alignItems: 'center',
            justifyContent: 'flex-start',
            position: 'relative',
            right: "".concat(indicatorSideSize / 2, "px"),
        } },
        React.createElement("div", { style: {
                height: "".concat(indicatorSideSize, "px"),
                aspectRatio: '1',
                borderRadius: '50%',
                backgroundColor: currentTimeLineColor,
                position: 'relative',
                bottom: "".concat((indicatorSideSize + cellBorderWidth) / 2, "px"),
            } }),
        React.createElement("div", { style: {
                width: "100%",
                borderTop: "".concat(cellBorderWidth, "px solid ").concat(currentTimeLineColor),
                position: 'relative',
                bottom: "".concat((indicatorSideSize + cellBorderWidth) / 2, "px"),
            } })));
};
export default WeeklyNowIndicator;
//# sourceMappingURL=WeeklyNowIndicator.js.map